import React from "react";

const testimonials = [
  {
    name: "Ramesh Kumar",
    role: "Home Owner",
    img: "https://randomuser.me/api/portraits/men/75.jpg",
  },
  {
    name: "Anita Sharma",
    role: "Business Owner",
    img: "https://randomuser.me/api/portraits/women/63.jpg",
  },
  {
    name: "Suresh Patel",
    role: "Contractor",
    img: "https://randomuser.me/api/portraits/men/64.jpg",
  },
  {
    name: "Priya Verma",
    role: "Interior Designer",
    img: "https://randomuser.me/api/portraits/women/45.jpg",
  },
  {
    name: "Amit Singh",
    role: "Site Supervisor",
    img: "https://randomuser.me/api/portraits/men/41.jpg",
  },
  {
    name: "Neha Gupta",
    role: "Home Maker",
    img: "https://randomuser.me/api/portraits/women/28.jpg",
  },
];


// 3-3 cards ke groups
const chunkArray = (arr, size) => {
  const result = [];
  for (let i = 0; i < arr.length; i += size) {
    result.push(arr.slice(i, i + size));
  }
  return result;
};

export default function Testimonial() {
  const slides = chunkArray(testimonials, 3);

  return (
    <section className="py-5 bg-white">
      <div className="container">

        {/* Heading */}
        <div className="text-center mb-5">
          <span className="text-primary fw-semibold">TESTIMONIAL</span>
          <h2 className="fw-bold mt-3">
            What Our Clients <br /> Say About Us
          </h2>
        </div>

        {/* Carousel */}
        <div
          id="testimonialCarousel"
          className="carousel slide"
          data-bs-ride="carousel"
          data-bs-interval="3000"
        >
          <div className="carousel-inner">

            {slides.map((group, slideIndex) => (
              <div
                key={slideIndex}
                className={`carousel-item ${slideIndex === 0 ? "active" : ""}`}
              >
                <div className="row g-4 justify-content-center">
                  {group.map((item, index) => (
                    <div className="col-md-4" key={index}>
                      <div className="card p-4 shadow text-center h-100">
                        <img
                          src={item.img}
                          alt={item.name}
                          className="rounded-circle mx-auto mb-3 border border-primary p-1"
                          width="70"
                        />
                        <h6 className="fw-bold mb-0">{item.name}</h6>
                        <small className="text-primary">{item.role}</small>
                        <div className="my-3 text-warning fs-5">★★★★★</div>
                    <p className="text-muted">
  “Quality pipes aur motors ka bahut achha collection hai.
  Service fast hai aur staff bhi helpful hai.”
</p>

                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}

          </div>

          {/* Controls */}
          <button
            className="carousel-control-prev"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="prev"
          >
            <span className="carousel-control-prev-icon"></span>
          </button>

          <button
            className="carousel-control-next"
            type="button"
            data-bs-target="#testimonialCarousel"
            data-bs-slide="next"
          >
            <span className="carousel-control-next-icon"></span>
          </button>

        </div>
      </div>
    </section>
  );
} 